export const styles = () => ({
  root: {
    position: 'fixed',
    top: 0,
    width: '100%',
    left: 0,
    zIndex: 2000,
    height: '20px',
  },
});
